import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import * as CryptoJS from 'crypto-js';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { v4 as uuidv4 } from 'uuid';
import { ModelLocatorService } from '../config/model-locator.service';
import { HttpService } from '../http-service/http.service';
const secretKey = 'U2FsdGVkX19aw/Ix91sETiRB1y0tGr9VGrn0jq9ZpmxsqUkbft4BnXij3oRZ2t7E';

@Injectable()
export class SafetyService {

    loading: any;
    statusRekognition: string;

    constructor(private httpService: HttpService,
        private modelLocator: ModelLocatorService,
        private loadingController: LoadingController) { }


    async presentLoading(msg: string) {
        this.loading = await this.loadingController.create({
            message: msg,
            spinner: 'bubbles'
        });
        await this.loading.present();
    }

    /**
     * Updates status documentacao
     * @author Starley Cazorla
     * @returns
     */
    async updateStatusDocumentacao() {
        return new Promise((resolve, reject) => {

            const config = this.httpService.setHeaderConfig(true);

            this.httpService.post(UrlConnectionEnum.UPDATE_STATUS_DOC, { "cpf": this.modelLocator.dadosLogin.cpf }, config).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            })

        });
    }

    /**
     * Uploads docs to s3
     * @author Starley Cazorla
     * @param imageBase64
     * @param nameToS3
     * @returns
     */
    async uploadDocsToS3(imageBase64: any, nameToS3: string) {
        return new Promise((resolve, reject) => {
            this.presentLoading('Enviando imagem...');
            let url = `${this.modelLocator.configUso.urlApiRekognition}/registration/${this.modelLocator.dadosLogin.cpf.replace(/[^0-9]/g, '')}/${nameToS3}`;

            const header = {
                'Content-Type': 'image/jpeg',
                'X-Amz-Security-Token': this.encrypt(this.modelLocator.configUso.tokenRekognition)
            }

            try {

                this.httpService.putExternal(url, imageBase64, header).subscribe({
                    next: (response) => {
                        console.log(response);
                        resolve('Imagem enviada');
                        this.loading.dismiss();
                    },
                    error: (error) => {
                        console.log(error);
                        reject(error);
                        this.loading.dismiss();

                    }
                })

            } catch (error) {
                reject(error);
                this.loading.dismiss();
            }
        });
    }

    /**
     * Sends img to rekognition
     * @author Starley Cazorla
     * @param imageBase64
     * @returns
     */
    async sendImgToRekognition(imageBase64: any) {
        return new Promise((resolve, reject) => {
            this.presentLoading('Validando imagem...');
            let ramdonUser = uuidv4();
            let url = `${this.modelLocator.configUso.urlApiRekognition}/audit/send/${this.modelLocator.dadosLogin.cpf.replace(/[^0-9]/g, '')}/${ramdonUser}.jpg`;

            const header = {
                'Content-Type': 'image/jpeg',
                'X-Amz-Security-Token': this.encrypt(this.modelLocator.configUso.tokenRekognition)
            }
            try {
                this.httpService.putExternal(url, imageBase64, header).subscribe({
                    next: async () => {
                        let result = await this.getResultOfRekognition(ramdonUser);
                        resolve(result);
                    },
                    error: (error) => {
                        console.log(error);
                        reject(error);
                        this.loading.dismiss();

                    }
                })

            } catch (error) {
                reject(error);
                this.loading.dismiss();
            }
        });
    }

    /**
     * Gets result of rekognition
     * @author Starley Cazorla
     * @param ramdonUser
     * @returns
     */
    getResultOfRekognition(ramdonUser: any) {
        return new Promise((resolve, reject) => {
            let url = `${this.modelLocator.configUso.urlApiRekognition}/audit/status?` + new URLSearchParams({
                userId: this.modelLocator.dadosLogin.cpf.replace(/[^0-9]/g, ''),
                hashKey: `${ramdonUser}`
            });

            const header = {
                'Content-Type': 'application/json',
                'X-Amz-Security-Token': this.encrypt(this.modelLocator.configUso.tokenRekognition)
            }
            try {
                this.httpService.getExternal(url, {}, header).subscribe({
                    next: async (response: any) => {
                        this.loading.dismiss();
                        response['hashKey'] = ramdonUser;
                        resolve(response);
                    },
                    error: (error) => {
                        console.log(error);
                        reject(error);
                        this.loading.dismiss();

                    }
                })

            } catch (error) {
                console.log(error);
                reject(error);
                this.loading.dismiss();
            }
        });
    }

    /**
     * Encrypts safety service
     * @author Starley Cazorla
     * @param data
     * @returns
     */
    encrypt(data: any) {
        const payload = {
            data: data,
            timestamp: new Date().getTime()
        }
        const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(payload), secretKey).toString();
        return ciphertext;
    }

}
